module.exports = __webpack_public_path__ + "img/wulun.dd9bea14.png";